import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function PaymentPolicy() {
  return (
    <PolicyPage title="Payment & Billing Policy">
      <h2>Accepted payment methods</h2>
      <p>The payment methods currently available are displayed at checkout. Availability may depend on your device, currency, billing country, and the payment provider. Displaying a payment logo does not guarantee that method will be available for every order.</p>

      <h2>Authorization and capture</h2>
      <p>When you place an order, the provider may authorize the estimated total. Funds may be captured when the order is accepted, fulfilled, or as otherwise disclosed at checkout. A temporary authorization can remain visible after a failed or cancelled order; your bank controls when it is released.</p>

      <h2>Currency, taxes, and conversion</h2>
      <p>The order currency and total are shown before payment. Your bank may charge conversion, cross-border, or other fees that we do not control. Taxes, shipping, and duties are included only where checkout expressly says so.</p>

      <h2>Payment security</h2>
      <p>Payments may be handled by an independent payment provider using its secure environment. camartzuno does not intentionally store complete card numbers or card security codes. Do not send payment credentials by email.</p>

      <h2>Verification and declined payments</h2>
      <p>We or the provider may use address, device, transaction, or identity checks to prevent fraud. A payment can be declined, delayed, or require additional authentication. Contact your payment provider first if it declines a valid transaction.</p>

      <h2>Duplicate or incorrect charges</h2>
      <p>Pending authorizations can look like duplicate charges. If two charges fully settle or the amount is wrong, email us with the order number, charge date, amount, and only the last four digits of the payment method. Never email a complete card number.</p>

      <h2>Refunds and disputes</h2>
      <p>Approved refunds return to the original payment method unless law requires otherwise. Banks may take additional time to post them. Contact us before starting a payment dispute so we have an opportunity to investigate; this request does not limit your legal rights.</p>

      <h2>Contact</h2>
      <p>Billing questions may be sent to <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default PaymentPolicy;
